"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogButtonAction = void 0;
function DialogButtonAction(options) {
    return function (target, propertyKey, _) {
        if (!target.dialogButtonActions) {
            target.dialogButtonActions = [];
        }
        const button = (target.dialogButtons || []).find((buttonDescriptor) => buttonDescriptor.propertyKey === `${propertyKey}Button`);
        if (!button) {
            throw new Error(`The DialogAction '${propertyKey}' should have a corresponding DialogButton named '${propertyKey}Button'`);
        }
        const actionDescriptor = {
            fn: target[propertyKey],
            keepOpenOnResolve: options?.keepOpenOnResolve,
            passErrors: options?.passErrors,
            targetButton: button,
            visibleWhen: options?.visibleWhen
        };
        target.dialogButtonActions.push(actionDescriptor);
    };
}
exports.DialogButtonAction = DialogButtonAction;
//# sourceMappingURL=DialogButtonAction.js.map